document.addEventListener('DOMContentLoaded', () => {
  const body = document.querySelector('body');
  const button = document.createElement('button');
  const buttonIcon = document.createElement('span');

  button.setAttribute('id', 'back-to-top');
  button.setAttribute('title', 'Botão de voltar ao topo');
  button.appendChild(buttonIcon);
  body.appendChild(button);

  if (window.scrollY === 0) {
    button.setAttribute('style', 'display:none;');
  }

  button.addEventListener('click', () => {
    window.scroll({
      top: 0,
      behavior: 'smooth',
    });
  });

  document.addEventListener('scroll', () => {
    if (window.scrollY > 0) {
      button.removeAttribute('style');
    } else {
      button.setAttribute('style', 'display:none;');
    }
  });
});
